export interface IAccessProviderInitialValues {
  userName: string;
  password: string;
}

export const accessFormInitialValues: IAccessProviderInitialValues = {
  userName: '',
  password: '',
};

export const eightHours = 1000 * 60 * 60 * 8;
